// 旅拍的服务内容卡片显示不可修改，仅展示用

import { checkoutArea } from '@components/LocalMerchant/SetMealCreate/utils'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React from 'react'
import style from './style.module.less'

const TravelPhotography = ({ sessionServiceStore }) => {
  const store = sessionServiceStore
  // 婚纱摄影-旅拍子类
  const isTravelPhotography = store.weddingPhotoType == '4'

  /**
   * @description 获取旅拍目的地取值
   */
  const getDestination = () => {
    const { centerStore } = store
    const { stepOneStore } = centerStore
    // 集合所有标签的列表，包括旅拍目的地
    const tagList = toJS(centerStore?.tag_list)
    // 获取区域id，国内 or 国外
    const areaId =
      toJS(stepOneStore?.form_values?.area) ||
      checkoutArea(tagList, stepOneStore.form)
    if (!tagList || !areaId) {
      return
    }

    // 筛选出选中的区域下的目的地列表
    const destinationList =
      centerStore?.tag_list?.find(f => f?.id == areaId)?.children ?? []
    const destination = toJS(destinationList).find(f => f.isActive)

    store.setDestinationCityId(destination?.mark_id)
    return destination
  }

  return (
    <>
      {isTravelPhotography && (
        <div className={style.travel}>
          <div className={style.title}>
            <img
              className={style.icon}
              src="//qnm.hunliji.com/o_1d21but2psea1tel1cdf1g6njme9.png"
            />
            <span>目的地</span>
          </div>
          {getDestination()?.name && (
            <div className={style.desc}>{getDestination()?.name}</div>
          )}
        </div>
      )}
    </>
  )
}

export default inject('sessionServiceStore')(observer(TravelPhotography))
